module.exports = __webpack_public_path__ + "static/durabilidad-122e1878f19e1f49625f5434e3955228.jpg";